export const getDiagram = (id) => {
    return fetch('/flowsheets/'+id+'/diagram', {mode: 'cors'});
}; 